import PropTypes from "prop-types"
import React from "react"
import { useMarina } from "src/contexts/MarinaContext"

import { formatCurrencyFromMinorUnits } from "src/utils/UnitConversion"

const Footer = ({
  sourceType,
  sourceId,
  contactBoats,
  sourceDates,
  sourceTotal,
}) => {
  const { presentmentCurrency } = useMarina()

  const renderBoatDetails = ({ name, make, model, encodedId }) => {
    const makeAndModel = [make, model].filter(Boolean).join(" ")
    return (
      <div key={encodedId}>{`${name}${
        makeAndModel ? `, ${makeAndModel}` : ""
      }`}</div>
    )
  }

  const renderSourceDates = () => {
    if (sourceDates) {
      return <div>{sourceDates}</div>
    }
  }

  const renderSourceTotal = () => {
    if (sourceTotal) {
      const formattedSourceTotal = formatCurrencyFromMinorUnits({
        amount: sourceTotal,
        currency: presentmentCurrency,
      })
      return `${sourceType} total: ${formattedSourceTotal}`
    }
  }

  return (
    <div data-testid="invoice-details-footer" className="!bg-gray-200 p-4">
      <div className="font-bold">DETAILS</div>
      <div>{`${sourceType} #${sourceId}`}</div>
      {contactBoats.map(renderBoatDetails)}
      {renderSourceDates()}
      {renderSourceTotal()}
    </div>
  )
}

export const contactBoatProps = {
  encodedId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  make: PropTypes.string,
  model: PropTypes.string,
}

Footer.propTypes = {
  sourceType: PropTypes.string.isRequired,
  sourceId: PropTypes.string.isRequired,
  contactBoats: PropTypes.arrayOf(PropTypes.shape(contactBoatProps)),
  sourceDates: PropTypes.string,
  sourceTotal: PropTypes.number,
}
export default Footer
